import { ChangeDetectionStrategy, Component, HostBinding, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewComponent, TreeNodeEvent } from '@libs/front/components/tree-view/tree-view.component';
import { NavLeftService } from 'src/app/services/nav-left.service';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector:        'app-nav-left',
  standalone:      true,
  imports:         [CommonModule, TreeViewComponent],
  templateUrl:     './nav-left.component.html',
  styleUrls:       ['./nav-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavLeftComponent {

  protected navLeft = inject(NavLeftService);
  protected device  = inject(DeviceService);

  // Replié en rail vertical : uniquement si la page l'autorise, et jamais sur mobile
  // (le nav-left y occupe tout l'écran et se masque via mobileNavVisible).
  protected isCollapsed = computed(
    () => !!this.navLeft.config().collapsible && this.navLeft.collapsed() && this.device.isDesktop()
  );

  @HostBinding('class.nav-left--collapsed') get hostCollapsed(): boolean {
    return this.isCollapsed();
  }

  // Largeur configurable (défaut : celle du app.component.scss). null = pas de surcharge.
  // Replié : la largeur du rail vient du app.component.scss.
  @HostBinding('style.width') get hostWidth(): string | null {
    return this.isCollapsed() ? null : (this.navLeft.config().width ?? null);
  }

  // Onglet actif — 'filter' par défaut, 'settings' si settingsTemplate fourni
  protected activeTab = signal<'filter' | 'settings'>('filter');

  // Affiche les onglets uniquement si settingsTemplate est fourni
  protected hasSettings = computed(
    () => !!this.navLeft.config().settingsTemplate
  );

  handleNodeClick(event: TreeNodeEvent): void {
    this.navLeft.config().onNodeClick?.(event);
    this.navLeft.hideMobileNav();
  }
}